import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-lg-500px bg-white rounded shadow-sm p-10 p-lg-15 mx-auto" }
const _hoisted_2 = { class: "fv-row mb-10" }
const _hoisted_3 = { class: "fv-plugins-message-container" }
const _hoisted_4 = { class: "fv-help-block" }
const _hoisted_5 = { class: "fv-row mb-10" }
const _hoisted_6 = { class: "fv-plugins-message-container" }
const _hoisted_7 = { class: "fv-help-block" }
const _hoisted_8 = { class: "text-center" }
const _hoisted_9 = ["disabled", "data-kt-indicator"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Form, {
      class: "form w-100",
      id: "kt_login_signin_form",
      onSubmit: _ctx.onSubmitLogin,
      "validation-schema": _ctx.login
    }, {
      default: _withCtx(() => [
        _cache[3] || (_cache[3] = _createElementVNode("div", { class: "text-center mb-10" }, [
          _createElementVNode("h1", { class: "text-dark mb-1" }, "ĐĂNG NHẬP"),
          _createElementVNode("h3", { class: "text-dark mb-3 text-uppercase" }, "Hệ thống lấy số thứ tự Xã Quảng Hà")
        ], -1)),
        _createElementVNode("div", _hoisted_2, [
          _cache[0] || (_cache[0] = _createElementVNode("label", { class: "form-label fs-6 fw-bolder text-dark" }, "Tài khoản", -1)),
          _createVNode(_component_Field, {
            class: "form-control form-control-lg form-control-solid",
            type: "text",
            name: "userName",
            autocomplete: "off"
          }),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_ErrorMessage, { name: "email" })
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _cache[1] || (_cache[1] = _createElementVNode("div", { class: "d-flex flex-stack mb-2" }, [
            _createElementVNode("label", { class: "form-label fw-bolder text-dark fs-6 mb-0" }, "Mật khẩu")
          ], -1)),
          _createVNode(_component_Field, {
            class: "form-control form-control-lg form-control-solid",
            type: "password",
            name: "password",
            autocomplete: "off"
          }),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_ErrorMessage, { name: "password" })
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("button", {
            disabled: _ctx.disabled,
            type: "submit",
            ref: "submitButton",
            id: "kt_sign_in_submit",
            "data-kt-indicator": _ctx.isLoading ? 'on' : null,
            class: "btn btn-lg btn-primary w-100 mb-5"
          }, [...(_cache[2] || (_cache[2] = [
            _createElementVNode("span", { class: "indicator-label" }, " Đăng nhập ", -1),
            _createElementVNode("span", { class: "indicator-progress" }, [
              _createTextVNode(" Đang tải... "),
              _createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
            ], -1)
          ]))], 8, _hoisted_9)
        ])
      ]),
      _: 1
    }, 8, ["onSubmit", "validation-schema"])
  ]))
}